module.exports = __webpack_public_path__ + "img/yd5@2x.f4a26537.png";